import React from 'react'

export const Page1Tamil = () => {
  return (
     <div className="page-tamil-container">
      <h1>முன்னுைர:</h1>
      <p>
        வணக்கம், கும்பாபிஷேக மலர் தயாரிப்பதும், கும்பாபிஷேகப் பணியில் ஒன்றாகவே
        அமைய வேண்டும். மலரை தயாரித்தவர் மலரைப் படிப்பவர்கள், மலரை தயாரிக்க
        பொருளுதவி செய்தவர்கள் அனைவருக்கும் கும்பாபிஷேகம் தரிசித்த பலனுண்டு.
      </p>
      <p>
        கொளப்பாடு ஸ்ரீ அய்யனார் ஸ்ரீ ஆதியண்ணன் ஆலயங்களுக்கு திருப்பணி செய்து
        கும்பாபிஷேகத்தையும் சிறப்பாக நடத்திய பெங்களூர் பக்தர்களின் விருப்பப்படி
        என்றும் வாடாத இந்த மலரை தயாரித்துள்ளேன். பொதுவாக விநாயகர், சிவன்,
        பெருமாள், மாரியம்மன், அய்யனார் போன்ற தெய்வங்களுக்கு புராண வரலாறு
        கிடைக்கும். ஆனால் இந்த மலரோ ஸ்ரீ ஆதியண்ண சுவாமி சம்பந்தப்பட்டது.
        கிராமத்தில் உள்ள வயதில் மூத்தவர் களிடம் கேட்டறிந்த செவிவழிச்
        செய்திகளையும், நான் நேரில் பார்த்த காட்சிகளையும் ஆதாரமாகக் கொண்டும்
        இம்மலர் வெளியிடப்பட்டுள்ளது. திருப்பணியில் பங்கேற்றவர்களின் சிலர் தங்கள்
        அனுபவங்களையும் இம்மலரில் பதித்துள்ளார்கள்.
      </p>
      <p>
        இம்மலரை வெளியிட எனக்கு உறுதுணையாய் இருந்த அன்பர்கள் அனைவருக்கும் அழகான
        முறையில் அச்சிட்ட திருவாரூர் மை கிராபிக்ஸ் நிறுவனத்திற்கும் என்றும்
        நன்றியும் வணக்கமும்.
      </p>
      <p>அன்புடன், சு. வாசுதேவன், தலைமை ஆசிரியர் ஒய்வு, கொளப்பாடு</p>
      <h1>ஸ்ரீ ஆதியண்ணன் துதி :</h1>
      <p>
        ஆதியும் அந்தமும் இல்லாதாகி சோதியாய் சுடர்விடும் ஒளியுமாகி ஆதியண்ணன் என்ற
        பெயர் கொண்டு மேதினியில் விளங்குகின்ற மேலான தெய்வமே எங்களுக்கு அருள்
        செய்வாய்
      </p>
      <h1>
        அருள்மிகு ஆதியண்ணன் துணை <br />
        அருள்மிகு அய்யனார் துணை
      </h1>
      <h1>இரு ஆலயங்களும் அமைந்துள்ள கொளப்பாடு கிராம தலவரலாறு :</h1>
      <p>
        கொளப்பாடு கிராமம் - நாகை மாவட்டத்தில் திருக்குவளை வட்டத்தில் கீவளூர்
        கச்சனம் வழித்தடத்தில் அமைந்துள்ளது. இந்த புண்ணிய தலத்திற்கு நான்கு
        திசைகளிலும் நான்கு பாடல் பெற்ற ஸ்தலங்கள் இருப்பதாலும், இவ்வூரிலும் ஸ்ரீ
        அகிலான்டேஸ்வரி சமேத சுந்தரேஸ்வரர் ஆலயமும் மற்றும் பல ஆலயங்கள் உள்ளதால்
        இந்த தலமும் சிறப்பு வாய்ந்ததாக எண்ணப்படுகிறது.
      </p>
      <p>
        இத் திருக்கோயில் அமைந்துள்ள கொளப்பாடு கிராமத்திற்கு வடதிசையில் பாடல்
        பெற்ற தலமான முன்னூத்திமங்கலம் என்றழைக்கப்பட்ட வலிவலம் ஸ்ரீ மனத்துணை
        நாதர் ஆலயம் உள்ளது.
      </p>
    </div>
  )
}
